import { Component, OnInit } from '@angular/core';

import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'authentication-conditions-modal',
    templateUrl: './authentication-conditions.component.html',
    styleUrls: ['./authentication-conditions.component.scss'],
})

/**
 * Componente para la modal de Políticas de Authentication (Login/Registro)
 */
export class AuthenticationConditionsModalComponent implements OnInit {
    public data;

    constructor(private readonly modalRef: DialogRef) {}

    public ngOnInit(): void {
        this.data = this.modalRef.data;
    }

    /**
     * Cierra la modal
     */
    public close(): void {
        this.modalRef.close();
    }
}
